<template>
  <div class="break-time">
    <div class="break-time__title">
      <p>{{ $t('routeOptimization.fields.breakTime') }}</p>
      <i
        id="break-time-tooltip"
        class="float-end input-tooltip-btn"
        :class="{
          'icon-outline_info': !isHover,
          'icon-fill_info': isHover,
        }"
        @mouseenter="isHover = true"
        @mouseleave="isHover = false"
      ></i>

      <b-tooltip target="break-time-tooltip" triggers="hover" placement="right">
        {{ $t('routeOptimization.tooltip.dailyRouteBreakTime') }}
      </b-tooltip>
    </div>

    <b-row>
      <b-col md="6">
        <McAlert
          v-if="disabled"
          variant="warning"
          :html="$t('routeOptimization.alertForm.breakTimeCondition')"
          withIcon
          :withGap="false"
          class="mb-2"
        />
      </b-col>
    </b-row>

    <div class="row">
      <div class="break-time__section col-12 col-sm-6">
        <FormulateInput
          class="__date-picker"
          name="options.fleet_shift_time.start_break_time"
          type="date-picker"
          datepickerType="time"
          format="HH:mm"
          icon="icon-outline_clock"
          placeholder="00:00"
          :disabled="disabled"
        />
        <div class="break-time__divider" />
        <FormulateInput
          class="__date-picker"
          name="options.fleet_shift_time.end_break_time"
          type="date-picker"
          datepickerType="time"
          format="HH:mm"
          icon="icon-outline_clock"
          placeholder="00:00"
          :disabled="disabled"
        />
      </div>
    </div>
  </div>
</template>

<script>
import McAlert from '@/components/McAlert'

export default {
  components: {
    McAlert,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isHover: false,
    }
  },
}
</script>

<style lang="scss" scoped>
.break-time {
  &__title {
    margin-bottom: 8px;
    font-size: 13px;
    display: flex;
    gap: 4px;
    align-items: center;

    p {
      margin: 0;
    }
  }

  &__section {
    display: flex;
    gap: 12px;
    align-items: center;

    .__date-picker {
      padding: 0;
      flex-grow: 1;
    }
  }

  &__divider {
    width: 12px;
    border-top: 1px solid #99a1b1;
  }
}
</style>
